<!--
 * @Author: filename
 * @Description: 专业资格证书
-->
<template>
    <div v-loading="isLoading">
        <div v-for="(item, i) in data.qualification" :key="i">
            <div :class="['box-title', i > 0 ? 'mt-20' : '']" :id="'qualifications'+i">
                <span>资格证书{{ i+1 }}</span>
                <div class="title-btn">
                    <!-- 显示状态下按钮 -->
                    <template v-if="!item.isEdit">
                        <el-popconfirm placement="top" title="确定删除？" @confirm="del(i)">
                            <el-button slot="reference">删除</el-button>
                        </el-popconfirm>
                        &nbsp;
                        <el-button type="primary" @click="editInfo(item)">编辑</el-button>
                    </template>
                    <!-- 编辑状态下按钮 -->
                    <template v-else>
                        <el-button :loading="item.isLoading" @click="cancel(item, i)">取消</el-button>
                        <el-button type="primary" :loading="item.isLoading" @click="checkInfo(i)">保存</el-button>
                    </template>
                </div>
            </div>
            <!-- 显示 -->
            <QualificationsDetail v-if="!item.isEdit" :data="item" />
            <!-- 编辑 -->
            <EditQualifications v-loading="item.isLoading" :ref="'qualification'+i" v-if="item.isEdit" :data="item" />
        </div>
    </div>
</template>

<script>
import EditQualifications from './C/EditQualifications.vue'
import QualificationsDetail from './C/QualificationsDetail.vue'
import { postClientInfo } from '../../../../../../api/gifted'
export default {
    props: {
        data: {
            type: Object,
            default:() => {}
        },
    },
    components: {
        EditQualifications,
        QualificationsDetail
    },
    data() {
        return {
            isLoading: false
        }
    },
    created() {
        this.setIsEdit()
    },
    methods: {
        // set isEdit
        setIsEdit() {
            this.data.qualification.forEach((item, i) => {
                this.$set(this.data.qualification[i], 'isEdit', false)
                this.$set(this.data.qualification[i], 'isLoading', false)
            })
        },
        // 取消
        cancel(item, index) {
            if (item.id) {
                item.isEdit = false
            } else {
                this.data.qualification.splice(index, 1)
            }
        },
        // 保存
        async saveInfo(index) {
            try {
                this.data.qualification[index].isLoading = true
                const parm = JSON.parse(JSON.stringify(this.data))
                parm.qualification[index] = this.$refs['qualification'+index][0].ruleForm
                const { code, data } = await postClientInfo(parm)
                if (code === 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    })
                    this.data.qualification[index].isEdit = false
                    this.data.qualification = data.qualification
                    this.data.component_score = data.component_score
                    this.setIsEdit()
                }
            } finally {
                this.data.qualification[index].isLoading = false
            }
        },
        // 编辑
        editInfo(item) {
            item.isEdit = true
        },
        // 保存
        checkInfo(index) {
            Promise.all([this.$refs['qualification'+index][0].checkParm()])
            .then(async () => {
                this.saveInfo(index)
            })
            .catch((err) => {
                console.log(err)
                setTimeout(() => {
                    this.$utils.scrollIntoError(this)
                }, 100)
            })
        },
        // 删除
        async del(index) {
            try {
                this.isLoading = true
                this.data.qualification.splice(index, 1)
                const { code, data } = await postClientInfo(this.data)
                if (code === 200) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    this.data.component_score = data.component_score
                }
            } finally {
                this.isLoading = false
            }
        },
        // 新增锚点到新增相应的位置
        anchorPoint() {
            this.$nextTick(() => {
                const pageId = document.querySelector('#qualifications' + (this.data.qualification.length - 1))
                pageId.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                })
            })
        }
    }
}
</script>

<style lang="less" scoped>
.info {
    padding: 10px 20px;
}
.box-title {
    padding: 8px 15px;
    background: #f2f2f2;
    color: #000;
    display: flex;
    align-items: center;
    span {
        flex: 1;
        font-weight: bold;
    }
    .title-btn {
        float: left;
    }
}
</style>
